import { useState, useContext } from "react";
import { Link, useParams } from "react-router-dom";
import { YearMap, SportsMapInv } from "./SportMap";

import {
  Avatar,
  Button,
  Table,
  TextInput,
  Label,
  Modal,
  List,
  Spinner,
} from "flowbite-react";
import { HiOutlineArrowRight, HiCurrencyDollar } from "react-icons/hi";

import { UIContext } from "../UIContext";
import { useTeam } from "../hooks/useTeam";
import { useAuth } from "react-oidc-context";

export const GetTeam = () => {
  const id = useParams().id;
  const auth = useAuth();
  const ctx = useContext(UIContext);
  const [openModal, setOpenModal] = useState(false);
  const [paymentMode, setPaymentMode] = useState(false);

  const { data: teamData, isLoading, isError } = useTeam(id);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spinner size="xl" />
      </div>
    );
  }

  if (isError || !teamData) {
    return (
      <div className="flex justify-center items-center h-screen">
        <p className="text-red-500">Could not fetch team info</p>
      </div>
    );
  }
  document.title = "NILO - " + teamData.name;

  const PaymentComponent = () => {
    if (auth.isAuthenticated === false) {
      return (
        <Button color="gray" onClick={() => auth.signinPopup()}>
          Endorse
          <HiOutlineArrowRight className="ml-2 h-5 w-5" />
        </Button>
      );
    }
    if (paymentMode === false) {
      return (
        <Button color="gray" onClick={() => setOpenModal(true)}>
          Endorse
          <HiOutlineArrowRight className="ml-2 h-5 w-5" />
        </Button>
      );
    }

    const handleSubmit = (e) => {
      e.preventDefault();
      let n = document.getElementById("amount").value;
      let s = {
        recipient: {
          type: "team",
          name: teamData.name,
          id: teamData.nilo_id,
        },
        amount: n * 100,
      };

      ctx.setLoading(true);
      fetch(`/api/stripe/pay`, {
        method: "POST",
        body: JSON.stringify(s),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${auth.user.access_token}`,
        },
      })
        .then((resp) => {
          ctx.setLoading(false);
          if (!resp.ok) {
            throw new Error("Cannot submit payment");
          }
          return resp.json();
        })
        .then((r) => {
          window.location.href = r.url;
        })
        .catch((err) => {
          console.error(err);
          ctx.setAlert({
            open: true,
            title: "Payment Error",
            message: `Payment failed: ${err.toString()}`,
            type: "Error",
          });
        });
    };

    return (
      <form onSubmit={handleSubmit}>
        <div>
          <Label htmlFor="amount" value="Amount" />
        </div>
        <TextInput
          id="amount"
          type="text"
          input="numeric"
          placeholder="0.00"
          icon={HiCurrencyDollar}
          required
        />
        <p />
        <Button type="submit">Submit</Button>
      </form>
    );
  };

  const ModalComponent = (props) => {
    const [openModal, setOpenModal] = props.modalState;
    const setPaymentMode = props.setPaymentMode;
    return (
      <Modal dismissable show={openModal} onClose={() => setOpenModal(false)}>
        <Modal.Header>Endorsement Terms</Modal.Header>
        <Modal.Body>
          <div className="flex space-y-6">
            <div>
              <p>
                NILO charges a service fee to the Athletes, to cover the costs
                of providing this service. The service includes, but isn't
                limited to -
                <List>
                  <List.Item>Athlete Verification</List.Item>
                  <List.Item>Validation</List.Item>
                  <List.Item>Contract Generation</List.Item>
                  <List.Item>Contract Fulfillment & Verification</List.Item>
                  <List.Item>Monetary Transactions</List.Item>
                </List>
              </p>
              <p>
                To support this service, NILO charges this Athlete a{" "}
                <b>10% service fee</b>.
              </p>
              <p>
                The Athlete will receive 90% of the amount you pay, with the
                remaining 10% going to pay for the service that NILO provides.
              </p>
            </div>
          </div>
          <hr className="space-y-6" />
          <div className="flex py-4">
            If these terms are acceptable, please click on the "Accept" button
            below.
          </div>
          <div className="flex py-4 space-x-10">
            <Button
              onClick={() => {
                setPaymentMode(true);
                setOpenModal(false);
              }}
            >
              Accept
            </Button>
            <Button
              color="gray"
              onClick={() => {
                setPaymentMode(false);
                setOpenModal(false);
              }}
            >
              Decline
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    );
  };

  return (
    <>
      <div className="flex flex-col md:flex-row">
        <div className="flex flex-col w-full sm:w-fit">
          <div className="rounded-md shadow-lg sm:mx-auto">
            <div className="min-w-full min-h-64 p-auto sm:p-20 ">
              {teamData.logourl !== undefined ? (
                <div
                  className="min-h-32 min-w-32 bg-no-repeat bg-center bg-contain"
                  style={{ backgroundImage: `url(${teamData.logourl})` }}
                />
              ) : (
                <div className="min-w-32 min-h-32 bg-no-repeat bg-center bg-contain bg-gray-300" />
              )}
            </div>
            <table className="border-separate px-8 mb:border-spacing-3 sm:border-spacing-x-8 sm:border-spacing-y-5 text-gray-500 text-left">
              <tbody>
                <tr className="py-2">
                  <td> Name: </td>
                  <td>
                    <p className="font-semibold pl-8">{teamData.name}</p>
                  </td>
                </tr>
                <tr className="py-2">
                  <td> Sport: </td>
                  <td>
                    <p className="font-semibold pl-8">
                      <Link to={`/Sport/${SportsMapInv[teamData.sport]}`}>
                        {SportsMapInv[teamData.sport]}
                      </Link>
                    </p>
                  </td>
                </tr>
                <tr className="py-2">
                  <td> Organization: </td>
                  <td>
                    <p className="font-semibold pl-8">{teamData.org}</p>
                  </td>{" "}
                </tr>
                <tr className="py-2">
                  <td> Conference: </td>
                  <td>
                    <Link to={`/Conf/${teamData.conference}`}>
                      <div className="font-semibold  pl-8 max-w-96">
                        {teamData.conference}
                      </div>
                    </Link>
                  </td>
                </tr>
                <tr className="py-2">
                  <td> Division: </td>
                  <td>
                    <Link to={`/Division/${teamData.division}`}>
                      <p className="font-semibold pl-8">{teamData.division}</p>
                    </Link>
                  </td>
                </tr>
                <tr className="py-2">
                  <td> Coach: </td>
                  <td>
                    <p className="font-semibold pl-8">{teamData.coach}</p>
                  </td>
                </tr>
                <tr className="py-2">
                  <td> Venue: </td>
                  <td>
                    <p className="font-semibold max-w-96 pl-8">
                      {teamData.venue}
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <PaymentComponent />
          <ModalComponent
            modalState={[openModal, setOpenModal]}
            setPaymentMode={setPaymentMode}
          />
        </div>
        <div>
          <div
            id="roster"
            className="mx-42 my-3 sm:mx-auto sm:my-auto sm:columns-3 md:columns-4 gap-16"
          >
            {teamData.roster.length > 0 &&
              teamData.roster.map((player) => {
                return (
                  <div
                    key={player.nilo_id}
                    className="flex break-inside-avoid-column px-8 py-4"
                  >
                    <Link to={`/Player/${player.nilo_id}`}>
                      <div className="font-extrabold">
                        {player.name.split(",").reverse().join(" ")}
                      </div>
                      <div className="font-light">
                        #{player.jersey}, {YearMap[player.year]}
                      </div>
                      <div className="font-medium">{player.position}</div>
                    </Link>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </>
  );
};
